// src/components/ErrorBoundary.js
// ──────────────────────────────────────────────────────────────────────────
// Catches render-time errors so visitors see a friendly screen (with a reload)
// instead of a blank white page.
// ──────────────────────────────────────────────────────────────────────────

import React from 'react';
import styled from 'styled-components';
import theme from '../theme/theme';

const Wrap = styled.div`
  min-height: 70vh; display: flex; flex-direction: column; align-items: center; justify-content: center;
  text-align: center; padding: 4rem 1.5rem; gap: 0.6rem;
  h1 { font-family: ${theme.font.display}; font-weight: 400; font-size: 2rem; color: ${theme.color.ink}; }
  p { color: ${theme.color.inkSoft}; max-width: 42ch; }
  button { margin-top: 1.2rem; background: ${theme.color.accent}; color: ${theme.color.onAccent};
           border: none; font-family: ${theme.font.body}; font-weight: 700; padding: 12px 26px;
           border-radius: ${theme.layout.radius}; cursor: pointer; }
  button:hover { background: ${theme.color.accentDark}; }
`;

class ErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { hasError: false }; }
  static getDerivedStateFromError() { return { hasError: true }; }
  componentDidCatch(error, info) { if (process.env.NODE_ENV !== 'production') console.error(error, info); }
  render() {
    if (this.state.hasError) {
      return (
        <Wrap>
          <h1>Something went wrong</h1>
          <p>Sorry about that. Please reload the page — if it keeps happening, get in touch and we’ll help.</p>
          <button onClick={() => window.location.reload()}>Reload page</button>
        </Wrap>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
